interface BadgeButtonProps {
  href: string;
  ariaLabel: string;
  children: React.ReactNode;
  onClick?: () => void;
}

function BadgeButton({ href, ariaLabel, onClick, children }: BadgeButtonProps) {
  return (
    <a
      href={href}
      aria-label={ariaLabel}
      onClick={onClick}
      target="_blank"
      rel="noreferrer"
      className="inline-flex flex-1 items-center justify-center gap-3 rounded-2xl bg-slate-900 px-5 py-3.5 text-white transition hover:bg-slate-800 active:scale-[0.985]"
    >
      {children}
    </a>
  );
}

interface Props {
  appStoreUrl: string;
  playStoreUrl: string;
  onAppStoreClick?: () => void;
  onPlayStoreClick?: () => void;
}

export function StoreBadges({
  appStoreUrl,
  playStoreUrl,
  onAppStoreClick,
  onPlayStoreClick,
}: Props) {
  return (
    <div className="flex w-full gap-3">
      <BadgeButton
        href={appStoreUrl}
        ariaLabel="App Store에서 우리엔 다운로드"
        onClick={onAppStoreClick}
      >
        <svg
          viewBox="0 0 24 24"
          className="h-7 w-7 shrink-0"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M16.365 1.43c0 1.14-.42 2.21-1.13 3-.78.86-2.05 1.53-3.08 1.45-.13-1.12.42-2.27 1.13-3.05.78-.86 2.13-1.5 3.08-1.4ZM20.82 17.18c-.55 1.21-.81 1.75-1.52 2.81-.99 1.49-2.39 3.34-4.13 3.36-1.55.02-1.95-1.01-4.05-1-2.1.01-2.55 1.02-4.1 1-1.74-.02-3.06-1.69-4.05-3.18C-.13 16.42-.6 11.42 1.04 8.82c1.16-1.84 3-2.91 4.74-2.91 1.77 0 2.88 1.02 4.34 1.02 1.42 0 2.29-1.02 4.34-1.02 1.55 0 3.2.85 4.36 2.32-3.83 2.1-3.21 7.57.99 8.95Z" />
        </svg>
        <div className="flex flex-col items-start leading-tight">
          <span className="text-[10px] font-medium uppercase tracking-wide text-slate-300">
            Download on the
          </span>
          <span className="text-base font-semibold">App Store</span>
        </div>
      </BadgeButton>
      <BadgeButton
        href={playStoreUrl}
        ariaLabel="Google Play에서 우리엔 다운로드"
        onClick={onPlayStoreClick}
      >
        <svg
          viewBox="0 0 24 24"
          className="h-7 w-7 shrink-0"
          aria-hidden="true"
        >
          <path d="M3.6 1.78A1.5 1.5 0 0 0 3 3v18a1.5 1.5 0 0 0 .6 1.22l10.4-10.21L3.6 1.78Z" fill="#34A853" />
          <path d="m17.66 8.22-3.66 3.59 3.66 3.59 3.7-2.05a1.5 1.5 0 0 0 0-3.08l-3.7-2.05Z" fill="#FBBC04" />
          <path d="m4.5 1.6 9.84 5.45-2.83 2.78L4.5 1.6Z" fill="#EA4335" />
          <path d="m4.5 22.4 7.01-8.83 2.83 2.78L4.5 22.4Z" fill="#4285F4" />
        </svg>
        <div className="flex flex-col items-start leading-tight">
          <span className="text-[10px] font-medium uppercase tracking-wide text-slate-300">
            Get it on
          </span>
          <span className="text-base font-semibold">Google Play</span>
        </div>
      </BadgeButton>
    </div>
  );
}
